module.exports = __webpack_public_path__ + "static/media/krestovina.679d2b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/krestovina.png
// module id = 169
// module chunks = 0